<div class="task-description m-b-40 flex flex-col" *ngIf="card">
  <div class="title">
    <i class="far fa-align-left"></i>Description
  </div>
  <div *ngIf="!isDescriptionEditing" class="description-contents" 
       (click)="startDescriptionEdit($event)"  [innerHTML]="card?.description | sanitizeHtml"
       ></div>
    

       
  <!-- <mat-form-field appearance="outline" class="w-p-100" [ngClass]="{'disabled': !hasPermission}"
                  *ngIf="isDescriptionEditing || !card.description || (card.description && card.description.length === 0)">
      <textarea matInput rows="4"
                id="task-description-box"
                matInput
                [formControl]="descriptionFormControl"
                (click)="startDescriptionEdit($event)"
                placeholder="Add a description"
                particleAnalytics
                analyticsCategory="description-box"
                analyticsAction="new-description-input"
      >
      </textarea>
  </mat-form-field> -->

<particle-text-editor  [ngClass]="{'disabled': !hasPermission}"
*ngIf="isDescriptionEditing|| (card.description && card.description.length === 0)"
[hideDac6CardLink]="true"
[replyToMessage]="null"
[hideEditorCloser]="false"
[disableEnterToSendMessage]="false"
[hideFileAttachment]="flase"
[hideAddLink]="true"
[hideAttachmentOption]="true"
[hideContactSuggestion]="true"
[hideEmojiIcon]="true"
[isChatEditor]="false"
[chatText]="card.description"
[hideSendButton]="true"
[showSaveButton]="true"
(cancelChatEditor)="resetDescriptionEditing($event)"
(outputChatEditorEvent)="onSaveDescriptionChange($event)"
>
</particle-text-editor>

  <!-- <div *ngIf="isDescriptionEditing" class="flex flex-row justify-start items-center" style="position: relative;">
    <button mat-button class="common-button"
            (click)="onSaveDescriptionChange()"
            particleAnalytics
            analyticsCategory="edit-item"
            analyticsAction="edit-item-btn">Save
    </button>
    <button mat-icon-button
            (click)="resetDescriptionEditing()"
            particleAnalytics
            analyticsCategory="cancel-edit-item"
            analyticsAction="cancel-edit-item-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div> -->
</div>
